import React from 'react';
import {TableEvento} from "./components/evento/TableEvento";
import {TableEditEvento} from "./components/evento/TableEditEvento";

const SeccionEventoGeneral = ({tipo, data, factura, reload}) => {
    return (
        <div className="mb-12">
            {tipo === 'S' && <TableEvento liquidacion={data}  factura={factura} reload={reload}/>}
            {tipo === 'N' && <TableEditEvento liquidacion={data}  factura={factura} reload={reload} />}
        </div>
    );
};

export default SeccionEventoGeneral;